import { createContext } from "react";

const ScreenWidth = createContext({
  screenSize: 0,
  setScreenSize: () => {},
});

export default ScreenWidth;
